import { useCallback, useContext } from 'react';
import WallboardContext from '../../contexts/WallboardContext';
import DashboardContext from '../../contexts/DashboardContext';
import isV5ChartDef from '../../types/visTypeCheckers/isV5ChartDef';
import updateDashboardGadget from '../../api/updateDashboardGadget';
import AnalyticsContext from '../../contexts/AnalyticsContext';
import AccountPickerContext from '../../contexts/AccountPickerContext';

const useOnDashboardGadgetEditSaved = () => {
  const { dashboard } = useContext(DashboardContext);
  const { isWallboard } = useContext(WallboardContext);
  const { trackEvent } = useContext(AnalyticsContext);
  const { selectedAccountId } = useContext(AccountPickerContext);

  const onSave = useCallback(
    (g: DashboardGadget) => {
      if (!dashboard) {
        const e = new Error();
        e.name = 'useOnDashboardGadgetEditSaved: dashboard not found';
        throw e;
      }

      trackEvent('Dashboard Card - Edit - Saved', {
        type: isV5ChartDef(g.chartDef) ? g.chartDef.gadgetType : '',
        dashboardId: dashboard.id,
        dashboardName: dashboard.name,
        isWallboardSlide: isWallboard ? 'true' : 'false',
      });

      updateDashboardGadget(g.id, g, selectedAccountId).then();
    },
    [dashboard, isWallboard, selectedAccountId, trackEvent],
  );

  return onSave;
};

export default useOnDashboardGadgetEditSaved;
